(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["impact-points"] && !Shopify.designMode) return;
  try {
    
  // Add event listener to document for clicks on elements with class 'impact-point-heading'
document.addEventListener('click', function(event) { 
  // Check if the clicked element or its parent has the class
  var clickedElement = event.target.closest('.impact-point-heading');
  
  if (clickedElement) {
    // Change background image
    var tabimagedesktop = clickedElement.getAttribute('data-img-desktop');
    var tabimagemobile = clickedElement.getAttribute('data-img-mobile');

    var sourceDesktop = document.querySelector('.impact-points-bg source[media="(min-width:466px)"]');
    var sourceMobile = document.querySelector('.impact-points-bg source[media="(max-width:465px)"]');

    if (sourceDesktop) {
      sourceDesktop.setAttribute('srcset', tabimagedesktop);
    }
    if (sourceMobile) {
      sourceMobile.setAttribute('srcset', tabimagemobile);
    }

    // Toggle active class for headings
    var headings = document.querySelectorAll('.impact-point-heading');
    headings.forEach(function(heading) {
      heading.classList.remove('active');
    });
    clickedElement.classList.add('active');

    // Toggle active class for descriptions
    var descriptions = document.querySelectorAll('.impact-point-description');
    descriptions.forEach(function(description) {
      description.classList.remove('active');
    });

    // Add active class to siblings of clicked element
    var siblingElements = Array.from(clickedElement.parentNode.children).filter(function(child) {
      return child !== clickedElement;
    });
    siblingElements.forEach(function(sibling) {
      sibling.classList.add('active');
    });
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-partners"] && !Shopify.designMode) return;
  try {
    
   let swiper = new Swiper('.mySwiper', {
    slidesPerView: 6,
    spaceBetween: 10,
    autoplay: {
      delay: 5500,
    },
    loop: true,
    breakpoints: {
      320: { slidesPerView: 1 },
      480: { slidesPerView: 1 },
      640: { slidesPerView: 4, spaceBetween: 10 },
      992: { slidesPerView: 4, spaceBetween: 10 }
    }
  });
  
  // Function to destroy or (re)init Swiper based on screen width
  function checkSwiper() {
    if (window.innerWidth < 640) {
      if (swiper) {
        swiper.destroy(true, true);
      }
    } else {
      if (!swiper || swiper.destroyed) {
        swiper = new Swiper('.mySwiper', {
          slidesPerView: 6,
          spaceBetween: 10,
          autoplay: {
            delay: 5500,
          },
          loop: true,
          breakpoints: {
            320: { slidesPerView: 1 },
            480: { slidesPerView: 1 },
            640: { slidesPerView: 4, spaceBetween: 10 },
            992: { slidesPerView: 4, spaceBetween: 10 }
          }
        });
      }
    }
  }
  
  window.addEventListener('resize', checkSwiper);
  checkSwiper();


  } catch(e) { console.error(e); }
})();
})();
